import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

class QuickReportPromptController {
  constructor($rootScope, $uibModalInstance, options) {
    var $ctrl = this;
    basicController($ctrl);
    $ctrl.paramsValues = {};

    var params = $ctrl.options.model.params;
    var report = $ctrl.options.model.report;
    $ctrl.paramsOnly = $ctrl.options.paramsOnly;

    params.forEach(function (x) {
      x = x.trim();

      if (x.indexOf("@dtm") > -1) {
        $ctrl.paramsValues[x] = moment();
      } else {
        $ctrl.paramsValues[x] = "";
      }
    });
    //console.info("$ctrl.paramsValues", $ctrl.paramsValues);
    var bus = ($ctrl.bus = new ServiceBus($rootScope));
    $ctrl.$uibModalInstance = $uibModalInstance;

    $ctrl.title = options.title || "Quick Report Parameters...";

    $ctrl.save = $ctrl.submit = function () {
      //console.info("ctrl.paramsValues", $ctrl.paramsValues);
      //console.info("cc", moment($ctrl.paramsValues[0]).format("MM-DD-YYYY"));
      var queryString = "";
      for (var x in $ctrl.paramsValues) {
        var value = $ctrl.paramsValues[x];
        if (x.indexOf("@dtm") > -1) {
          //$ctrl.paramsValues[x] = moment();
          //console.info(x, $ctrl.paramsValues[x].format("YYYY-MM-DD"));
          value = $ctrl.paramsValues[x].format("YYYY-MM-DD");
        }

        if (value.length > 0 && typeof value === "object") {
          if (value[0].hasOwnProperty("status")) {
            var ids = value.map(function (obj) {
              return obj.status;
            });
          } else if (value[0].hasOwnProperty("erpStatus")) {
            var ids = value.map(function (obj) {
              return obj.erpStatus;
            });
          } else {
            var ids = value.map(function (obj) {
              return obj.id;
            });
          }

          queryString += "&" + x + "=" + ids.join("|");
        } else {
          queryString += "&" + x + "=" + value;
        }
      }

      if ($ctrl.paramsOnly) $ctrl.$close($ctrl.paramsValues);
      else {
        let url = $ctrl.$appConfig.resolveServiceUrl(
          "RunReport?reportName=QuickReport&displayName=" +
            report.name +
            " &output=xlsx&QuickReportID=" +
            report.id +
            "&QuickReportName=" +
            report.name +
            queryString
        );
        //console.log("url", url);
        return (location.href = url);
      }
    };
  }
  $onInit() {
    const $ctrl = this;
  }

  isClearText(param) {
    if (
      param.indexOf("@dtm") == -1 &&
      param.indexOf("@strVendor") == -1 &&
      param.indexOf("@Vendor") == -1 &&
      param.indexOf("@VendorMulti") == -1 &&
      param.indexOf("@strShowCode") == -1 &&
      param.indexOf("@ShowCode") == -1 &&
      param.indexOf("@ShowCodeMulti") == -1 &&
      param.indexOf("@strSalesRep") == -1 &&
      param.indexOf("@SalesRep") == -1 &&
      param.indexOf("@RepID") == -1 &&
      param.indexOf("@RepMulti") == -1 &&
      param.indexOf("@strWritingRep") == -1 &&
      param.indexOf("@WritingRep") == -1 &&
      param.indexOf("@WritingRepMulti") == -1 &&
      param.indexOf("@strOrderStatus") == -1 &&
      param.indexOf("@OrderStatus") == -1 &&
      param.indexOf("@OrderStatusMulti") == -1 &&
      param.indexOf("@strERPStatus") == -1 &&
      param.indexOf("@ERPStatus") == -1 &&
      param.indexOf("@ERPStatusMulti") == -1 &&
      param.indexOf("@strOrderSource") == -1 &&
      param.indexOf("@OrderSource") == -1 &&
      param.indexOf("@OrderSourceMulti") == -1 &&
      param.indexOf("@strRepGroup") == -1 &&
      param.indexOf("@RepGroup") == -1 &&
      param.indexOf("@strRegion") == -1 &&
      param.indexOf("@Region") == -1 &&
      param.indexOf("@strPromoList") == -1 &&
      param.indexOf("@PromoList") == -1 &&
      param.indexOf("@bolActive") == -1 &&
      param.indexOf("@bolActive") == -1
    ) {
      return true;
    } else {
      return false;
    }
  }
  dismiss(reason) {
    let $ctrl = this;
    $ctrl.$uibModalInstance.dismiss(reason);
  }
}

export default QuickReportPromptController;
